import CircularProgress from "@material-ui/core/CircularProgress"
import Fab from "@material-ui/core/Fab"
import Link from "@material-ui/core/Link"
import * as React from "react"
import { useHistory } from "react-router-dom"
import { appTheme } from "../StyleUtils"

interface FormWrapperProps {
    onClick: () => void
    disabled: boolean
    loading?: boolean
    buttonLabel: string
    className?: string
    firstForm?: boolean
}

export const FormWrapper: React.FC<FormWrapperProps> = ({onClick, children, disabled, loading, buttonLabel, className, firstForm}) => {

    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
                flexGrow: 1
            }}
            className={className}
        >
            {children}
            <FormButtons disabled={disabled} firstForm={firstForm} onClick={onClick}>
                {loading ?
                    <CircularProgress color={"inherit"} size={appTheme.spacing(4)}/> :
                    buttonLabel
                }
            </FormButtons>
        </div>
    )
}

export const FormButtons: React.FC<{ disabled?: boolean, firstForm?: boolean, onClick: () => void }> = ({children, disabled, firstForm, onClick}) => {
    const history = useHistory()

    function goBack() {
        history.goBack()
    }

    return (
        <div style={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridGap: appTheme.spacing(3),
            marginTop: appTheme.spacing(3),
            justifyContent: "space-between"
        }}>
            {!firstForm && (
                <Link
                    variant={"body2"}
                    onClick={goBack}
                    style={{
                        color: appTheme.palette.primary.main,
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        alignSelf: "center",
                        letterSpacing: "1.3px",
                        cursor: "pointer"
                    }}
                >
                    back
                </Link>
            )}
            <Fab
                variant={"extended"}
                color={"primary"}
                disabled={disabled}
                onClick={onClick}
                style={{gridColumn: firstForm ? "1 / 3" : ""}}
            >
                {children}
            </Fab>
        </div>
    )
}